export const ORDER_SHOPS_GET_LIST = "/ordershops";